import { currentPage } from '../common/layout';
import 'jquery-mousewheel';
import '../common/polymer/webcomponents-init';
import '../common/lightgallery/jquery-lightgallery';
import '../common/lightgallery/jquery-lightgallery-aside';
import '../common/lightgallery/jquery-lightgallery-additional';
import '../common/lightgallery/jquery-lightgallery-topside';
import '../common/lightgallery/jquery-lightgallery-custom-content';
import '../common/msnt/msnt-lightslider.js';
import 'jquery-scrolltie';
import '../common/cmp-bubbles';
import { msntPhotoThumbGallery } from '../common/msnt/msnt-photo-thumb-gallery';
import '../common/widgets/widget-points-of-interest';
import { compareImages } from '../common/widgets/widget-compare-images';
import '../common/jquery.sticky';
// import '../common/lot-linx-car';
import m1FindVehicleEu from '../common/shop/m1-find-vehicle-eu';
import m1FindVehicleUs from '../common/shop/m1-find-vehicle-us';
import { loadGallery } from '../common/msnt/msnt-photo-gallery-helper';
import { faqAccordeon } from '../common/widgets/widget-faq';
import '../common/lightzoom';
// import '../common/trinity-audio.js';


currentPage.pageInit = ($page, pageData, pageId) => {
  $(".sidebar").stickySidebar({containerSelector: ".content-area"});
  // bigImgLazyload();
  m1FindVehicleEu();
  m1FindVehicleUs();
  compareImages();
  msntPhotoThumbGallery();
  faqAccordeon();
  var resTimeout = null,
    $window = $(window),
    $mosaicEl = $('#top_box.mosaic-wrapper'),
    $filterBoxNav = $('.filterBoxNav');

  // $window
  //   .on('filter-dropdown-list', function(){
  //     fn.filterDropdownList('#filters_box');
  //   })
  //   .on('resize init', function(){
  //     clearTimeout(resTimeout);
  //     resTimeout = setTimeout(function(){
  //       fn.filterDropdownList('#filters_box');
  //     },100);
  //   }).trigger('init');

  $filterBoxNav.on('click', 'a', function(event) {
    var hash = $(this).attr('href').split('#')[1];
    if (!hash) return;

    event.preventDefault();
    $('html, body').animate({
      scrollTop: $('#' + hash).offset().top,
    },
      300,
      function() {
      window.location.hash = hash;
    }
  );
  });

  $('#top_box .item .poster').scrollTie({
    property: 'translateY',
    delay: function(el){
      return 350;
    },
    stopAtValue: document.documentElement.clientHeight,
    speed: isTouch ? 0.15 : 0.3
  });

  // fire custom event to show check availability form
  $('#getQuoteCurrent').on('click', function() {
    var $btn = $(this),
      id = $btn.data('inventory-id');

    document.dispatchEvent(new CustomEvent('get-quote', {
      detail: {
        id: id,
        section: 'oem',
        leadParams: $btn.data('lead-params'),
      },
    })
  );
  });

  loadGallery({
    arrayPhotos: false,
    galleryId: null,
    indexOf: null,
    $galleryList: $mosaicEl,
    onMobileOff: false,
    additionalParams: {
      selector: $mosaicEl.find('.mosaic-header_item'),
      singleLoad: true,
    },
  });
  
  function scrollToAnchorFunc(trigger, anchor) {
    const $elem = document.querySelector(trigger);
    const toAnchor = document.querySelector(anchor);
    let toAnchoroffsetTop;
   
    if ($elem && toAnchor) {
      toAnchoroffsetTop = toAnchor.getBoundingClientRect();
    }

    function scrollToAnchor(element) {
      window.scrollTo({ top:element, behavior: 'smooth'});
    };

    if ($elem && toAnchor) {
      $elem.addEventListener("click", () => {
        scrollToAnchor(toAnchoroffsetTop.y);
      });
    }
    
  }; 

  // scrollToAnchorFunc(".latest_reviews_btn", '.latest_reviews_anchor');
  scrollToAnchorFunc(".prices-table_btn", '.prices-table_anchor');

  if ($('.lightzoom').length > 0) {
    $( '.lightzoom' ).lightzoom({
     speed:                 100,   // скорость появления
     imgPadding:            1,    // значение отступа у изображения
     overlayOpacity:        '0.5', // прозрачность фона (от 0 до 1)
     viewTitle:             false, // true, если надо показывать подпись к изобажению
     isOverlayClickClosing: true, // true, если надо закрывать окно при клике по затемненной области
     isWindowClickClosing:  true, // true, если надо закрывать окно при клике по любой области
     isEscClosing:          true, // true, если надо закрывать окно при нажатии на кнопку Esc
     boxClass:              '',    // позволяет задавать класс окну обертке (с версии 1.1.0)
     overlayColor:          '',    // позволяет задавать цвет фону (с версии 1.1.0)
     titleColor:            '',    // позволяет задавать цвет подписи (с версии 1.1.0)
   });
 }

 if ($(".submodel-trims").length > 0) {
  function updateBrowseBox() {
      const loadMoreBtn = document.getElementById('loadMore');
      const browseBox = document.querySelector('.submodel-trims-text-content');
      let isExpanded = false;
      const width = window.innerWidth;
      const selector = width > 767 ? ".submodel-trims-text-content > *:nth-child(n+4)" : ".submodel-trims-text-content > *:nth-child(n+3)";

          loadMoreBtn.addEventListener('click', () => {
              isExpanded = !isExpanded;
              
              if (isExpanded) {
              browseBox.querySelectorAll('.submodel-trims-text-content > *').forEach((p) => {
                  p.style.display = 'block';
              });
              // loadMoreBtn.textContent = 'hide';
              } else {
              browseBox.querySelectorAll(selector).forEach((p) => {
                  p.style.display = 'none';
              });
              // loadMoreBtn.textContent = 'leggi di più';
              }
          });
  }

  updateBrowseBox();

  window.addEventListener("resize", updateBrowseBox);
}

};
